import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';


const LoginPage = () => {
    const [login, setLogin] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate();

    const handleLogin = (e) => {
        e.preventDefault();
        if (login === 'osnova' && password === 'u7W^2ci!8T') {
            localStorage.setItem('isAdminAuthenticated', 'true');
            navigate('/admin/register-clinic');
        } else {
            setError('Неверный логин или пароль');
        }
    };

    return (
                <div className="max-w-md mx-auto bg-gray-800 p-8 rounded-lg shadow-lg border border-gray-300">
            <h2 className="text-2xl font-bold text-center text-gray-900 mb-6">Вход для администратора</h2>
            <form onSubmit={handleLogin}>
                {error && <p className="text-red-500 text-center mb-4">{error}</p>}
                <div className="mb-4">
                    <label htmlFor="login" className="block text-sm font-medium text-gray-300 mb-2">Логин</label>
                    <input
                        id="login"
                        type="text"
                        value={login}
                        onChange={(e) => setLogin(e.target.value)}
                        required
                        className="w-full bg-white border border-gray-300 rounded-md p-2.5 text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-purple-500 transition-colors"
                    />
                </div>
                <div className="mb-6">
                    <label htmlFor="password" className="block text-sm font-medium text-gray-300 mb-2">Пароль</label>
                    <input
                        id="password"
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                        className="w-full bg-white border border-gray-300 rounded-md p-2.5 text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-purple-500 transition-colors"
                    />
                </div>
                <button type="submit" className="gradient-button w-full text-gray-900 font-medium py-3 px-6 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 transition duration-200">
                    Войти
                </button>
            </form>
        </div>
    );
};

export default LoginPage;
